module.exports = __webpack_public_path__ + "static/images/6d5f276f.png";